import { brand } from "../data/site";

export default function WhatsAppFab() {
    const msg = "Hello BRA Sheriff — I would like to know more about your projects.";
    const url = `https://wa.me/${brand.phoneRaw}?text=${encodeURIComponent(msg)}`;
    return (
        <a
            href={url}
            target="_blank"
            rel="noreferrer"
            aria-label="Chat with us on WhatsApp"
            className="group fixed z-50 right-5 bottom-5 md:right-8 md:bottom-8 inline-flex items-center justify-center w-14 h-14 md:w-16 md:h-16 rounded-full bg-[#C89B3C] text-[#0b0b0b] shadow-[0_20px_60px_-15px_rgba(200,155,60,0.7)] hover:bg-[#E2C56D] hover:scale-105 transition-[transform,background-color] duration-300"
            data-testid="whatsapp-fab"
        >
            <svg
                width="26"
                height="26"
                viewBox="0 0 24 24"
                fill="currentColor"
                aria-hidden
            >
                <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 2.1.55 4.15 1.6 5.96L2 22l4.26-1.7a9.9 9.9 0 0 0 5.78 1.86h.01c5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.86 9.86 0 0 0 12.04 2Zm0 18.06h-.01a8.15 8.15 0 0 1-4.16-1.14l-.3-.18-2.53 1 1.02-2.46-.19-.31a8.14 8.14 0 0 1-1.25-4.34c0-4.5 3.66-8.16 8.16-8.16 2.18 0 4.23.85 5.77 2.39a8.11 8.11 0 0 1 2.39 5.78c0 4.5-3.66 8.16-8.16 8.16Zm4.72-6.11c-.26-.13-1.53-.75-1.77-.84-.24-.09-.41-.13-.58.13-.17.26-.66.84-.81 1.01-.15.17-.3.19-.55.06-.26-.13-1.1-.4-2.09-1.29-.77-.69-1.29-1.55-1.44-1.81-.15-.26-.02-.4.11-.53.11-.11.26-.3.39-.45.13-.15.17-.26.26-.43.09-.17.04-.32-.02-.45-.06-.13-.58-1.4-.8-1.92-.21-.5-.42-.43-.58-.44l-.5-.01a.95.95 0 0 0-.69.32c-.24.26-.9.88-.9 2.15s.93 2.5 1.06 2.67c.13.17 1.83 2.79 4.44 3.91.62.27 1.1.43 1.48.55.62.2 1.19.17 1.63.1.5-.07 1.53-.63 1.75-1.23.22-.6.22-1.11.15-1.22-.06-.11-.24-.17-.5-.3Z" />
            </svg>
        </a>
    );
}
